import {
  getColorScheme,
  updateColorScheme,
} from "@/lib/helpers/colorScheme.helpers";
import { ColorSchemeContext, type ColorSchemeType } from "@/lib/main";
import { ReactNode, useLayoutEffect, useState } from "react";

const ColorSchemeProvider = ({ children }: { children: ReactNode }) => {
  const [colorScheme, setColorScheme] = useState<ColorSchemeType>(() =>
    getColorScheme(),
  );

  useLayoutEffect(() => {
    updateColorScheme(colorScheme);
  }, [colorScheme]);

  const toggleColorScheme = () => {
    setColorScheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ColorSchemeContext.Provider value={{ colorScheme, toggleColorScheme }}>
      {children}
    </ColorSchemeContext.Provider>
  );
};

export default ColorSchemeProvider;
